export default __webpack_public_path__ + "static/512-db404107da64e3d419d0987ba1be9d2d.gif";